export * from "./routes";
export const MEETING_PERIOD = 40;
export const SYSTEM_PROTECTED = "system protected";
export const PROTECTED = "protected";
export const SEARCH_URL = "/search";
export const TEACHER_JOURNEY_URL = "/teacher";
export const STUENT_JOURNEY_URL = "/student";
export const STUDENT_HOME_URL = "/student";
export const HOME_URL = "/";
export const STUDENT_PROFILE_SETTING_PAGE_URL = "/student/settings";
export const TEACHER_PROFILE_SETTING_PAGE_URL = "/teacher/settings";
export const Dynamo_URL = "/dynamo";
export const Blog_url = "/blog";
export const About_url = "/about";
export const AllBlogs_url = "/blogs";
export const Privacy_url = "/privacy";
export const DeleteAccount_url = "/delete-account";
export const Contact_url = "/contact";
export const ReturnRefund_url = "/return-refund";
export const Terms_url = "/terms";
export const PaymentFailed_url = "/payment-failed";
export const PaymentSuccess_url = "/payment-success";
export const PaymentTest_url = "/payment-test";

export const TEACHER_ROLE = "teacher";
export const STUDENT_ROLE = "student";
export const GOOGLE_CLIENT_ID =
  "559665393661-i14ueink1e0p0g9ccdsgdisc6mc0r3rd.apps.googleusercontent.com";
export const AUTH_TOKEN = "auth-token";
export const USER_SIGN_UP_DETAIL = "userSignUpDetail";
export const IS_TEACHER_SCHEDULE_CREATED = "isTeacherScheduleCreated";
export const STATUS_BOOKED = "booked";
export const STATUS_AVAILABLE = "available";
export const MONTHLY_TYPE = "monthly";
export const SESSION_TYPE = "session";
export const DEMO_TYPE = "demo";
export const RETAKE_TYPE = "retake";

export const MODE_OF_TEACHING = {
  ONLINE: "Online",
};

export const SLOT_STATUSES = {
  COMPLETED: "completed",
  DELIVERED: "delivered",
};

export const filters = [
  {
    filterHeader: "Gender",
    filterOptions: [
      {
        id: 1,
        name: "Male",
      },
      {
        id: 2,
        name: "Female",
      },
    ],
    isOpen: true,
  },
  {
    filterHeader: "Teaching Mode",
    filterOptions: [
      {
        id: 1,
        name: "Online",
      },
      {
        id: 2,
        name: "Home",
      },
      // {
      //   id: 3,
      //   name: "Both",
      // },
    ],
    isOpen: true,
  },
  // {
  //   filterHeader: "Availability",
  //   filterOptions: [
  //     {
  //       id: 1,
  //       name: "online",
  //     },
  //     {
  //       id: 2,
  //       name: "offline",
  //     },
  //   ],
  // },
];

export const membership = {
  a: "Free Plan",
  b: "Six Month Membership PKR600",
  c: "Six Month Membership PKR900",
};

export const offerStatuses = {
  DELIVERED: "delivered",
  WITH_DRAWN: "withdrawn",
  ACCEPTED: "accepted",
  REJECTED: "rejected",
  PENDING: "pending",
  EXPIRED: "expired",
  DEMO: "demo",
};

export const MESSAGE_TYPES = {
  TEXT: "TEXT",
  AUDIO: "AUDIO",
  OFFER: "OFFER",
  MEETING_LINK: "MEETING_LINK",
};

export const USER_MEDIA_TYPES = {
  PROFILE_PICTURE: "profilePicture",
};

export const OFFER_TYPE_MESSAGES = {
  DEMO: "New Demo Request",
  OFFER: "New Offer Request",
};

export const TEACHING_MODE = {
  HOME: "home",
  ONLINE: "online",
};

export const moveToTeacherSearchScreen = (searchText) => {
  return `${SEARCH_URL}?query=${searchText}&gender=""&modeOfTeaching=""&cityId=""`;
};
